import { Users, Layers, CheckCircle, XCircle } from 'lucide-react';

export default function StatsCards({ stats }) {
  const cards = [
    {
      label: 'Total Groups',
      value: stats.total,
      icon: Layers,
      iconClass: 'gm-stat-icon-teal',
    },
    {
      label: 'Active',
      value: stats.active,
      icon: CheckCircle,
      iconClass: 'gm-stat-icon-green',
    },
    {
      label: 'Inactive',
      value: stats.inactive,
      icon: XCircle,
      iconClass: 'gm-stat-icon-amber',
    },
    {
      label: 'Total Users',
      value: stats.totalUsers,
      icon: Users,
      iconClass: 'gm-stat-icon-blue',
    },
  ];

  return (
    <div className="gm-stats-grid">
      {cards.map((card) => (
        <div key={card.label} className="gm-stat-card">
          <div className={`gm-stat-icon ${card.iconClass}`}>
            <card.icon size={20} />
          </div>
          <div className="gm-stat-body">
            <p className="gm-stat-value">{card.value}</p>
            <p className="gm-stat-label">{card.label}</p>
          </div>
        </div>
      ))}
    </div>
  );
}
